// Image assets — official Tahitian Move brand photos provided by the client.
export const IMG = {
  logo:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/duomhdy5_Logo-TAM-Savate-Tahiti-1977-WhiteTurquoise-%282%29.png',

  // HERO — woman in coral dress, tropical leaves print (vibrant, editorial)
  heroLifestyle:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/jrvzsdgx_482272966_1076379951191420_259088546213267628_n.jpg',
  // Alternate hero / Femme b-roll
  heroFemale:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/bqzac0cw_Kalea_White%20%282%29.jpg',

  // Iconic savates — coquillages turquoise (footwear signature)
  sandals:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/qnjsym0z_Coquillages-Turquoise-Blanc.jpg',
  // Framed savates — gallery / heritage display
  savatesGallery:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/k18t2j1l_484870310_1081674863995262_8485815343642356400_n.jpg',
  // Surf culture / heritage collage
  heritageSurf:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/dt92wbc4_484755549_1084142863748462_1323979587072616557_n.jpg',

  // Heritage — vintage photo of Enio Chiocchi (founder) with his partner — Tahitian Move origins
  heritageVintage:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/4eqidalc_Messenger_creation_3CA7F27E-2CB4-4C64-AD83-F69D0AEABF84.jpeg',
  heritageCouple:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/52qudyd6_1976.png',
  tiare:
    'https://images.pexels.com/photos/37401132/pexels-photo-37401132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',

  // Boutique
  boutique:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/8a11ff3r_boutique.jpg',
  // Custom hand-made map showing the boutique location (Fare Ute, Papeete)
  locationMap:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/pk7ekyy3_localisation.png',

  // Category visuals — official brand photos
  catFemme:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/q45pnogl_484068572_1081322654030483_5692843321242569309_n.jpg', // woman with hat, blue floral dress
  catHomme:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/qgn62v7x_483890252_1081322687363813_6780688133417956388_n.jpg', // man, blue floral shirt
  catAccessories:
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/kzmxe1h8_width_1193.webp',

  // Lagoon accent
  lagoon:
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80',

  // Chaussant gallery — lifestyle photos of Tahitian Move savates collections
  chaussantGallery: [
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/wcxynl93_489538569_1102483461914402_6077769506326414302_n.jpg',
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/hue3jwtf_485151559_1085065580322857_1253011063406943807_n.jpg',
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/0mf5p8d6_601526498_1317402970422449_4552540349764537129_n.jpg',
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/tlyootz5_698558352_1451253067037438_4069755824908242312_n.jpg',
    'https://customer-assets.emergentagent.com/job_island-style-1/artifacts/zckfpjlz_331543641_192917620231068_923850946115887692_n.jfif',
  ],
};
